// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__uf2Kf","article-header":"Article_article-header__v95dd","articleHeader":"Article_article-header__v95dd"};